export class PMDTModel{
    id:any;
    pmdtsiteName: any;
    contact:any;
    address:any;
    districtId: any;
    isActive: any;
}